import React from "react";

interface Props {
  children: React.ReactChild;
  [key: string]: any;
}

// HomeV2 ships its own Navbar/Footer as part of the page, so this layout
// intentionally renders no chrome (unlike DefaultLayout).
const HomeV2Layout = ({ children }: Props) => {
  return <>{children}</>;
};

export default HomeV2Layout;
